import Vue from 'vue'
import {mapGetters, mapActions} from 'vuex'
import SupportTypes from 'js/services/api/passenger/supportType'
import iconoCanalAtencion from 'assets/images/ico-soporte.svg'
import template from 'js/pages/municipality/index.pug'

// @vue/component
export default Vue.extend({
  name: 'municipality-page',
  template: template(),
  data() {
    return {
      supportTypes: []
    };
  },
  
  computed: {
    selected() {
      return this.items.find(i => i.value === this.$route.name)
    },

    activeTab() {
      return this.selected?.label || this.$t('defaultLayout.options.home')
    },

    isMobileDevice() {
      // devDump("detected device", this.$device)
      return ['mobile'/* , 'tablet' */].includes(this.$device)
    },

    /** Este método deberia de sobre escribirse con las personalizaciones de cliente */
    items() {
      let items = [
        // CORE: estarán siempre en todas las ciudades.
        {
          value: HOME_ROUTE, // This comes from webpack constants and no import is necessary
          icon: 'inicio',
          label: this.$t('defaultLayout.options.home')
        },
        {
          value: 'municipality-routes',
          icon: 'lineas',
          label: this.$t('defaultLayout.options.routes')
        },
        {
          value: 'municipality-stops',
          icon: 'paradas',
          label: this.$t('defaultLayout.options.stops')
        },
        {
          value: 'municipality-point-of-sales',
          icon: 'ventas',
          label: this.$t('defaultLayout.options.sales')
        }
      ]

      return items;
    }
  },

  watch: {
    administrativeArea(newValue) {
      if (newValue !== null && newValue !== undefined && newValue !== '') {
        this.getSupportTypes()
      }
    }
  },

  async created() {
    let municipalityRoutes = this.$router.getRoutes().filter(r => r.name?.startsWith('municipality')).map(r => ({
      name: r.name,
      hasComponent: !!r.components?.default || !!r.component
    }))
    // devDump('municipalityRoutes', municipalityRoutes)
  },

  methods: {
    ...mapActions(['resetAccessibilityTabs']),
    ...mapActions('administrativeArea', ['loadAdministrativeAreaFromMunicipality']),
    ...mapActions('appConfig', ['loadAppConfig']),

    validarmenu(enable_abt_account) {
      try {
        if (enable_abt_account != undefined && enable_abt_account != {}) {
          if (enable_abt_account.config.enable_abt_account != undefined) {
            if (enable_abt_account.config.enable_abt_account === false) {
              return false
            } else {
              return true
            }
          } else {
            return true
          }
        }
      } catch (error) {
        return true
      }
      return true
    },

    rechargeIcon() {
      // verifica si tiene media_type TSC monedero
      const media_type_1 = this.administrativeArea.media_types?.some(
        types => types.code.toString() === '1'
      )

      // verifica si tiene support_type TSC producto
      const support_type_1 = this.supportTypes?.some(types => types.code.toString() === '1')

      if (!media_type_1 && !support_type_1) {
        if (!this.administrativeArea?.enable_qr) {
          return true
        }
      }

      return false
    },

    async getSupportTypes() {
      const params = {
        administrative_area_id: this.administrativeArea.id
      }

      const supportTypes = await SupportTypes.index(params)
      this.supportTypes = supportTypes
    },

    removeFixedClass() {
      document.documentElement.classList.remove("device-fixed");
      document.documentElement.style.removeProperty("--vh");
    },


    menuOptionClass(item) {
      let classes = {
        active: this.$route.name.includes(item.value),
        disabled: item.disabled,
      }
      if(item.label.length > 15) {
        classes.longText = true
      }
      return classes
    },

    hideComputedName(value) {
      const optionName = _.startCase(_.camelCase(value)).replace(/ /g, "");
      return `hide${optionName}`;
    },
    
    find() {
      return iconoCanalAtencion
    }
  }
})
